<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
          <b-form-input
            v-model="search"
            size="sm"
            class="mr-sm-2"
            placeholder="Chercher par nom"
          ></b-form-input>
          <div class="col text-right">
            <base-button
              style="
                background-color: #000;
                width: 150px;
                height: 50px;
                color: #fff;
                margin-top: 10px;
              "
              size="sm"
              @click="$refs.addSP.setId()"
              >Ajouter</base-button
            >
          </div>
        </div>
      </div>
    </div>

    <div>
      <base-table
        class="table align-items-center"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="filteredData"
      >
        <template slot="columns">
          <th>ID</th>
          <th>Nom</th>

          <th>Attributs</th>

          <th></th>
        </template>

        <template slot-scope="{ row }">
          <td class="budget">{{ row.id }}</td>
          <td>{{ row.name }}</td>
          <td>
            <div v-if="row.attributes">
              <div
                v-for="(attr, index) in row.attributes.split(';')"
                :key="index"
                style="margin-bottom: 5px"
              >
                {{
                  attr.substring(
                    0,
                    attr.indexOf("~~") > 0 ? attr.indexOf("~~") : attr.length
                  )
                }}
                <div
                  @click="deleteAttribute(row.id, row.name, attr)"
                  style="
                    display: inline-block;
                    font-size: 25px;
                    cursor: pointer;
                    color: red;
                    margin-left: 5px;
                  "
                >
                  <b-icon icon="trash"></b-icon>
                </div>
                <div
                  @click="
                    updateAttribute(
                      row.id,
                      row.name,
                      row.attributes,
                      attr.substring(
                        0,
                        attr.indexOf('~~') > 0
                          ? attr.indexOf('~~')
                          : attr.length
                      ),
                      attr.indexOf('~~') > 0
                        ? attr.substring(attr.indexOf('~~') + 2)
                        : '',
                      attr
                    )
                  "
                  style="
                    display: inline-block;
                    font-size: 25px;
                    cursor: pointer;
                    color: blue;
                    margin-left: 5px;
                  "
                >
                  <b-icon icon="pencil"></b-icon>
                </div>
              </div>
            </div>
          </td>
          <td class="text-right">
            <b-button
              size="sm"
              class="mr-2"
              @click="addAttributes(row.id, row.name, row.attributes)"
              >Ajouter un attribut</b-button
            >
            <b-button
              style="margin-left: 5px"
              size="sm"
              class="mr-2"
              @click="showConfirm(row.id)"
              >Supprimer ce produit</b-button
            >
          </td>
        </template>
      </base-table>
    </div>
    <GStockLoader :loading="loading" />
    <AddAttribute ref="addAttribute" @updated="getSPs" />
    <UpdateAttributes ref="updateAttribute" @updated="getSPs" />
    <AddSP ref="addSP" @updated="getSPs" />
  </div>
</template>
<script>
import GStockLoader from "@/components/Loader";
import AddAttribute from "./AddAttribute";
import UpdateAttributes from "./UpdateAttributes";
import AddSP from "./AddSP";
import { get, put, del } from "@/mixins/api";
export default {
  name: "UserTable",
  components: {
    GStockLoader,
    AddAttribute,
    AddSP,
    UpdateAttributes,
  },
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      data: [],
      loading: false,
      tableData: [],
      search: "",
    };
  },
  computed: {
    filteredData() {
      return this.tableData.filter((x) =>
        (x.name + "").toLowerCase().includes(this.search.toLowerCase())
      );
    },
    rows() {
      return this.data.count;
    },
  },
  methods: {
    showConfirm(id) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Vous confirmez que vous allez supprimer ce produit ?", {
          title: "Confirmez Svp!",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "OUI",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            del(`stp/${id}`).then(() => {
              this.getSPs();
            });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    deleteAttribute(id, name, attr) {
      const sp = this.tableData.find((x) => x.id == id);
      if (sp) {
        put("stp", {
          id,
          name,
          attributes: sp.attributes
            .split(";")
            .filter((x) => x != attr)
            .join(";"),
        }).then(() => {
          this.getSPs();
        });
      }
    },
    addAttributes(id, name, attr) {
      this.$refs.addAttribute.setId(
        id,
        name,
        attr.length != 0 ? attr.split(";") : []
      );
    },
    updateAttribute(id, name, attributes, attr, values, previous) {
      this.$refs.updateAttribute.setId(
        id,
        name,
        attributes.split(";"),
        attr,
        values.length != 0 ? values.split("~") : [],
        previous
      );
    },
    getSPs() {
      this.tableData = [];
      get("stp").then((response) => {
        this.tableData = response.data.data;
      });
    },
  },
  mounted() {
    this.getSPs();
  },
};
</script>
<style>
</style>
